module.exports = __webpack_public_path__ + "img/lordsmobile-guide.337b6f3.jpg";